import { render } from "./FilesUploader.vue?vue&type=template&id=4a485816"
import script from "./FilesUploader.vue?vue&type=script&lang=js"
export * from "./FilesUploader.vue?vue&type=script&lang=js"

import "./FilesUploader.vue?vue&type=style&index=0&id=4a485816&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__